import { Link, useLocation } from "react-router-dom";
import { cognitoLogout } from "@/lib/auth";
import { FileSearch, Settings, LogOut, Shield } from "lucide-react";
import { cn } from "@/lib/utils";
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarFooter,
  SidebarHeader,
  useSidebar,
} from "@/components/ui/sidebar";

export function SupportSidebar() {
  const location = useLocation();
  const { state } = useSidebar();
  const isCollapsed = state === "collapsed";
  const isActive = location.pathname === "/support-dashboard";

  return (
    <Sidebar collapsible="icon" className="border-r-0">
      <SidebarHeader className="p-4">
        <div className={cn("flex items-center gap-3 transition-all duration-200", isCollapsed && "justify-center")}>
          <div className="w-10 h-10 rounded-xl bg-destructive/10 flex items-center justify-center">
            <Shield className="w-5 h-5 text-destructive" />
          </div>
          {!isCollapsed && (
            <div className="animate-fade-in">
              <p className="font-semibold text-foreground text-sm">Support Team</p>
              <p className="text-xs text-muted-foreground">Moderation</p>
            </div>
          )}
        </div>
      </SidebarHeader>

      <SidebarContent className="px-2">
        <SidebarGroup>
          <SidebarGroupLabel className="text-xs font-semibold uppercase tracking-widest text-muted-foreground/60 px-3">
            Reviews
          </SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarMenu>
              <SidebarMenuItem>
                <SidebarMenuButton asChild isActive={isActive} tooltip={isCollapsed ? "Profile Reviews" : undefined}>
                  <Link to="/support-dashboard" className={cn("group relative flex items-center gap-3 transition-all duration-200", isActive && "font-medium")}>
                    <FileSearch className={cn("w-5 h-5 transition-colors", isActive ? "text-primary" : "text-muted-foreground group-hover:text-foreground")} />
                    <span className={cn("flex-1 transition-colors", isActive ? "text-primary" : "text-muted-foreground group-hover:text-foreground")}>
                      Profile Reviews
                    </span>
                  </Link>
                </SidebarMenuButton>
              </SidebarMenuItem>
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>

      <SidebarFooter className="p-2">
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton asChild tooltip={isCollapsed ? "Settings" : undefined}>
              <Link to="/settings" className="flex items-center gap-3 text-muted-foreground hover:text-foreground transition-colors">
                <Settings className="w-5 h-5" />
                {!isCollapsed && <span>Settings</span>}
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>
          <SidebarMenuItem>
            <SidebarMenuButton asChild tooltip={isCollapsed ? "Log out" : undefined}>
              <button onClick={() => cognitoLogout()} className="flex items-center gap-3 text-muted-foreground hover:text-destructive transition-colors w-full">
                <LogOut className="w-5 h-5" />
                {!isCollapsed && <span>Log out</span>}
              </button>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarFooter>
    </Sidebar>
  );
}
